import { render, staticRenderFns } from "./AddLayoutModal.vue?vue&type=template&id=057750b8&scoped=true"
import script from "./AddLayoutModal.vue?vue&type=script&lang=js"
export * from "./AddLayoutModal.vue?vue&type=script&lang=js"
import style0 from "./AddLayoutModal.vue?vue&type=style&index=0&id=057750b8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057750b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('057750b8')) {
      api.createRecord('057750b8', component.options)
    } else {
      api.reload('057750b8', component.options)
    }
    module.hot.accept("./AddLayoutModal.vue?vue&type=template&id=057750b8&scoped=true", function () {
      api.rerender('057750b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/AddLayoutModal.vue"
export default component.exports